import { render, staticRenderFns } from "./Redeem.vue?vue&type=template&id=0c095746&scoped=true"
import script from "./Redeem.vue?vue&type=script&lang=js"
export * from "./Redeem.vue?vue&type=script&lang=js"
import style0 from "./Redeem.vue?vue&type=style&index=0&id=0c095746&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c095746",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c095746')) {
      api.createRecord('0c095746', component.options)
    } else {
      api.reload('0c095746', component.options)
    }
    module.hot.accept("./Redeem.vue?vue&type=template&id=0c095746&scoped=true", function () {
      api.rerender('0c095746', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sections/Redeem.vue"
export default component.exports